import FirewallList from './FirewallList';
import FirewallEdit from './FirewallEdit';

const firewallsV2 = {
    list: FirewallList,
    edit: FirewallEdit,
};

export default firewallsV2;
